export const TEST_ID_BASE = "check-security-clearance";

export const LANG_BASE = "security-clearance";

export const CHECK_SECURITY_CLEARANCE_SERVICE = "bff-gatepass";

export const CHECK_PAGE_LOGO_SRC = {
  desktop: "/fujairah-ports-authority.svg",
  mobile: "/fujairah-ports-authority.svg",
} as const;

export const CHECK_PAGE_LANGUAGE_ICON_SRC = "/accessibility-language-check-page-icon.png";
